import { getAdminRoutePermission } from '../../adminRoutes';

const createLink = getAdminRoutePermission((x) => x.rateOptionNew);
const editLink = getAdminRoutePermission((x) => x.rateOptionEdit);

export const optionListPermissions = {
    createLink,
    editLink,
};
